<template>
  <div class="app-wrapper">
    <div class="main-container layout">
      <navbar />
      <!-- <sidebar class="sidebar-container" /> -->
      <IAside class="sidebar-container" />
      <TagsView class="tags"></TagsView>
      <RescuePopup></RescuePopup>
      <div class="ud-content">
        <app-main />
      </div>
      <footer class="ud-footer">©版权所有 浙江春风动力股份有限公司</footer>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { Navbar, AppMain, TagsView, RescuePopup } from './components/index';
import IAside from './components/IAside.vue';
import rescueMixin from '@/mixins/rescue/index.js';
console.log(rescueMixin);
export default {
  name: 'Layout',
  components: {
    Navbar,
    // Sidebar,
    AppMain,
    TagsView,
    IAside,
    RescuePopup,
  },
  mixins: [rescueMixin],
  computed: {
    ...mapState('app', {
      sidebar: (state) => state.sidebar,
    }),
  },
};
</script>

<style lang="scss" scoped>
@import '../../../styles/mixin';
.app-wrapper {
  @include clearfix;
  position: relative;
  height: 100%;
  width: 100%;
}
.main-container {
  /*min-height: 100%;*/
  transition: margin-left 0.28s;
  // margin-left: 180px;
}
</style>
